/**
 * 模块: 品牌竞争网络控制面板
 * 职责: 提供SKU、周期、频率选择和操作按钮
 * 限制: 文件<280行
 */

import React from 'react';
import { Card, Select, Space, Button, Slider, Typography } from 'antd';
import { FireOutlined, ReloadOutlined } from '@ant-design/icons';
import type { SKU, Period } from './types';

const { Text } = Typography;
const { Option } = Select;

interface NetworkControlsProps {
  skus: SKU[];
  periods: Period[];
  selectedSKU: number | undefined;
  selectedPeriod: number | undefined;
  minFrequency: number;
  generating: boolean;
  loading: boolean;
  onSKUChange: (value: number) => void;
  onPeriodChange: (value: number | undefined) => void;
  onFrequencyChange: (value: number) => void;
  onGenerate: () => void;
  onRefresh: () => void;
}

export const NetworkControls: React.FC<NetworkControlsProps> = ({
  skus,
  periods,
  selectedSKU,
  selectedPeriod,
  minFrequency,
  generating,
  loading,
  onSKUChange,
  onPeriodChange,
  onFrequencyChange,
  onGenerate,
  onRefresh,
}) => {
  return (
    <Card className="control-card" style={{ marginBottom: 16 }}>
      <Space size="large" wrap>
        <Space>
          <Text>选择SKU:</Text>
          <Select
            style={{ width: 250 }}
            placeholder="选择SKU"
            value={selectedSKU}
            onChange={onSKUChange}
          >
            {skus.map(sku => (
              <Option key={sku.id} value={sku.id}>
                {sku.name} ({sku.asin})
              </Option>
            ))}
          </Select>
        </Space>

        <Space>
          <Text>选择周期:</Text>
          <Select
            style={{ width: 200 }}
            placeholder="全部周期"
            allowClear
            value={selectedPeriod}
            onChange={onPeriodChange}
          >
            {periods.map(period => (
              <Option key={period.id} value={period.id}>
                {period.week_number}
              </Option>
            ))}
          </Select>
        </Space>

        <Space>
          <Text>最小竞争频率:</Text>
          <Slider
            style={{ width: 150 }}
            min={1}
            max={20}
            value={minFrequency}
            onChange={onFrequencyChange}
            tooltip={{ formatter: (value) => `≥${value}` }}
          />
          <Text type="secondary">≥{minFrequency}</Text>
        </Space>

        <Space>
          <Button
            type="primary"
            icon={<FireOutlined />}
            loading={generating}
            onClick={onGenerate}
          >
            生成网络
          </Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={onRefresh}
            loading={loading}
          >
            刷新
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

